import { ModalBackground, ModalContent, ModalFooter, ModalLayout, ModalTitle } from './ModalForms';
import BasicButton from 'components/Buttons/BasicButton';
import { font, palette } from 'styles/Global/globalStyles';
import styled from 'styled-components';
import { ViewDetailDiagnosisPageDiagnosisMemoCancelConfirmModalProps } from 'models/Hospital/viewDetailDiagnosisPageTypes';
import { CloseButtonWrapper } from 'styles/Modal/modalStyle';
import CloseDialogue from 'assets/Icons/DeleteIcon/CloseDialogue';
import Noti_Warning from 'assets/Icons/ToastIcons/Noti_Warning';

const DiagnosisMemoCancelConfirmModal = ({
    setIsLeaveModal,
    clickLeaveButtonInLeaveModal,
    title,
    firstContent,
    secondContent,
    firstButton,
    secondButton,
    temporarySelectedTap,
}: ViewDetailDiagnosisPageDiagnosisMemoCancelConfirmModalProps) => {
    return (
        <ModalBackground>
            <ModalLayout $width='520px'>
                <ModalTitleAndContentContainer>
                    <TitleAndIconWrapper>
                        <Noti_Warning />
                        <ModalTitle>{title}</ModalTitle>
                    </TitleAndIconWrapper>
                    <ModalContentWrapper>
                        <ModalContent $fontSize={font.size[16]} $height='22px' $fontWeight={font.weight.regular}>
                            {firstContent}
                        </ModalContent>
                        {secondContent && (
                            <ModalContent $fontSize={font.size[16]} $height='22px' $fontWeight={font.weight.regular}>
                                {secondContent}
                            </ModalContent>
                        )}
                    </ModalContentWrapper>
                </ModalTitleAndContentContainer>
                <ModalFooter>
                    <BasicButton $width='160px' $height='48px' onClick={setIsLeaveModal} $type='anotherFill'>
                        {firstButton}
                    </BasicButton>
                    <BasicButton $width='160px' $height='48px' $type='warning' onClick={clickLeaveButtonInLeaveModal}>
                        {secondButton}
                    </BasicButton>
                </ModalFooter>
                <CloseButtonWrapper onClick={setIsLeaveModal}>
                    <CloseDialogue />
                </CloseButtonWrapper>
            </ModalLayout>
        </ModalBackground>
    );
};

export default DiagnosisMemoCancelConfirmModal;

const ModalTitleAndContentContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    gap: 12px;
`;
const ModalFooterWrapper = styled.div`
    display: flex;
    gap: 8px;
`;

const TitleAndIconWrapper = styled.div`
    display: flex;
    gap: 8px;
`;

const ModalContentWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
`;
